import { RefreshButton } from '@bumble/app/components/RefreshButton';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from '@mui/material';
import { DurationLikeObject } from 'luxon';
import { useState } from 'react';

interface TimeRangeProps {
  timeValues: { label: string; value: DurationLikeObject }[];
  selectedTime: DurationLikeObject;
  onTimeChange: (e: React.MouseEvent<HTMLElement>, v: DurationLikeObject) => void;
  onRefresh: () => void;
  leftContent?: React.ReactNode;
}
const TimeRange = ({ timeValues, selectedTime, onTimeChange, onRefresh, leftContent }: TimeRangeProps) => {
  const [rotateIcon, setRotateIcon] = useState(0);

  const handleRefreshClick = () => {
    setRotateIcon(rotateIcon + 1);
    onRefresh();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: leftContent ? 'space-between' : 'flex-end',
        flexWrap: 'wrap',
        mb: { xs: 5, md: 0 },
      }}
    >
      {leftContent}
      <Box sx={{ textAlign: 'right' }}>
        <Typography variant="subtitle1" sx={{ mr: 5, display: { xs: 'block', md: 'inline' } }}>
          Time Range:
        </Typography>
        <ToggleButtonGroup
          value={selectedTime}
          exclusive
          color="primary"
          onChange={onTimeChange}
          aria-label="text alignment"
          sx={{ background: 'white', display: { xs: 'flex', md: 'inline-flex' }, mr: 5 }}
        >
          {timeValues.map(({ label, value }) => (
            <ToggleButton
              value={value}
              aria-label={label}
              key={label}
              sx={{
                fontWeight: 700,
                px: { xs: 2, md: 5 },
                textTransform: 'none',
                flexGrow: 1,
              }}
            >
              {label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <RefreshButton onRefresh={handleRefreshClick} />
      </Box>
    </Box>
  );
};

export default TimeRange;
